module.exports = __webpack_public_path__ + "static/media/workoutChest.4728b02c.png";